import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Privacidade() {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-28 sm:pt-36 md:pt-48 pb-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-primary mb-6 break-words">
            Termos de Privacidade e Segurança
          </h1>
          <p className="text-text-grey font-semibold mb-1">
            LicitMax Consultoria Especializada em Licitações e Contratos Administrativos
          </p>
          <p className="text-text-grey mb-8">Campo Mourão, Paraná</p>

          <div className="space-y-8 text-text-grey leading-relaxed [&_p]:text-justify [&_h2]:text-primary [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:mb-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2">
            <section>
              <h2>1. Introdução</h2>
              <p>
                Este documento estabelece os termos de privacidade e segurança do website e dos
                serviços de concierge comercial ofertados pela LicitMax Consultoria Especializada
                em Licitações e Contratos Administrativos ("Escritório" ou "LicitMax"). Nós nos
                comprometemos com a proteção de seus dados pessoais conforme a Lei Geral de
                Proteção de Dados (LGPD) e as melhores práticas de mercado.
              </p>
            </section>

            <section>
              <h2>2. Coleta de Dados</h2>
              <p>
                Ao interagir com nossa assistente virtual (Bia) ou solicitar contato, coletamos os
                seguintes dados pessoais:
              </p>
              <ul>
                <li>Nome completo</li>
                <li>Número de WhatsApp com DDD (identificador de contato)</li>
                <li>Cidade e Estado (UF) da empresa</li>
                <li>Segmento de atuação e resumo da situação relatada</li>
                <li>Histórico da conversa (sessionStorage, excluído ao encerrar sessão)</li>
                <li>Informações técnicas: endereço IP, tipo de navegador, timestamp de acesso</li>
              </ul>
              <p>
                A coleta é realizada <strong>exclusivamente com consentimento implícito</strong> ao
                iniciar conversa com a Bia. Você pode não fornecer dados e encerrar a sessão a
                qualquer momento.
              </p>
            </section>

            <section>
              <h2>3. Finalidades do Tratamento</h2>
              <p>Seus dados são processados para:</p>
              <ul>
                <li>Entender o perfil e o segmento da sua empresa</li>
                <li>Avaliar a viabilidade de atuação em licitações públicas</li>
                <li>Facilitar contato direto via WhatsApp pela equipe da LicitMax</li>
                <li>Melhoria contínua da experiência do usuário no site</li>
                <li>Conformidade legal e auditoria interna</li>
              </ul>
            </section>

            <section>
              <h2>4. Notificação via Telegram</h2>
              <p>
                Quando você conclui o registro do contato, um resumo de seus dados (nome, WhatsApp,
                cidade/UF, segmento) é automaticamente enviado via API do Telegram para o grupo
                privado de leads do Escritório. Este processo:
              </p>
              <ul>
                <li>
                  É realizado apenas <strong>uma vez por conversação</strong> (anti-duplicação via
                  identificador de conversa)
                </li>
                <li>Utiliza conexão criptografada (HTTPS)</li>
                <li>O registro é armazenado de forma segura no servidor</li>
                <li>Você será contatado pela equipe da LicitMax pelo WhatsApp informado</li>
              </ul>
            </section>

            <section>
              <h2>5. Segurança de Dados</h2>
              <p>Implementamos medidas técnicas e organizacionais para proteger seus dados:</p>
              <ul>
                <li>
                  <strong>Arquitetura segura:</strong> chaves de API não são expostas no frontend;
                  todas as requisições passam por um proxy PHP no backend
                </li>
                <li>
                  <strong>Encriptação:</strong> comunicação via HTTPS (TLS 1.2+)
                </li>
                <li>
                  <strong>Armazenamento temporário:</strong> histórico de chat permanece apenas em
                  sessionStorage (memória do navegador), não em banco de dados público
                </li>
                <li>
                  <strong>Isolamento:</strong> identificador único de conversa garante
                  rastreabilidade e auditoria
                </li>
                <li>
                  <strong>Logs:</strong> registrados com timestamp em São Paulo
                  (America/Sao_Paulo) para conformidade
                </li>
              </ul>
            </section>

            <section>
              <h2>6. Retenção de Dados</h2>
              <ul>
                <li>
                  <strong>Chat conversacional:</strong> descartado ao fechar o navegador
                  (sessionStorage)
                </li>
                <li>
                  <strong>Contatos qualificados:</strong> mantidos no sistema Telegram do
                  Escritório conforme política interna (máximo 90 dias)
                </li>
                <li>
                  <strong>Logs de servidor:</strong> retidos por 30 dias para auditoria e
                  diagnóstico
                </li>
              </ul>
            </section>

            <section>
              <h2>7. Direitos do Titular dos Dados</h2>
              <p>Conforme a LGPD, você tem direito a:</p>
              <ul>
                <li>
                  <strong>Acesso:</strong> solicitar cópia de seus dados coletados
                </li>
                <li>
                  <strong>Retificação:</strong> corrigir informações imprecisas
                </li>
                <li>
                  <strong>Exclusão ("direito ao esquecimento"):</strong> remover dados, exceto
                  aqueles com obrigação legal de retenção
                </li>
                <li>
                  <strong>Portabilidade:</strong> receber seus dados em formato estruturado
                </li>
                <li>
                  <strong>Oposição:</strong> recusar o processamento para fins específicos
                </li>
              </ul>
              <p>
                Para exercer esses direitos, envie uma solicitação por e-mail para{' '}
                <strong>contato@licitmax.com.br</strong> ou pelo WhatsApp do Escritório, informando
                claramente qual direito deseja exercer.
              </p>
            </section>

            <section>
              <h2>8. Cookies e Rastreamento</h2>
              <p>Utilizamos:</p>
              <ul>
                <li>
                  <strong>sessionStorage:</strong> armazenamento local do histórico de chat (dados
                  do navegador, não transmitidos a terceiros)
                </li>
                <li>
                  <strong>Ferramentas de análise de tráfego:</strong> dados agregados e
                  anonimizados sobre navegação no site, quando aplicável
                </li>
              </ul>
              <p>
                Você pode desabilitar cookies no navegador ou usar modo privado/anônimo. Isso não
                impede o acesso ao website, apenas limita a funcionalidade de persistência de
                sessão.
              </p>
            </section>

            <section>
              <h2>9. Compartilhamento de Dados</h2>
              <p>
                Seus dados <strong>não são compartilhados</strong> com terceiros, exceto:
              </p>
              <ul>
                <li>
                  <strong>Equipe interna do Escritório:</strong> exclusivamente para análise da
                  viabilidade e atendimento comercial
                </li>
                <li>
                  <strong>Obrigações legais:</strong> se requerido por autoridade competente
                </li>
              </ul>
            </section>

            <section>
              <h2>10. Conformidade com a LGPD</h2>
              <p>Este processamento é legítimo sob as seguintes bases:</p>
              <ul>
                <li>
                  <strong>Consentimento:</strong> inicial, ao interagir com a Bia
                </li>
                <li>
                  <strong>Interesse legítimo:</strong> funcionamento do serviço de consultoria
                </li>
                <li>
                  <strong>Obrigação legal:</strong> conformidade com regulações e auditoria
                </li>
              </ul>
            </section>

            <section>
              <h2>11. Sigilo e Exclusividade</h2>
              <p>
                Todos os dados fornecidos estão sob sigilo profissional. A LicitMax atua com
                exclusividade por segmento e não divulga informações sobre sua empresa sem
                autorização expressa.
              </p>
            </section>

            <section>
              <h2>12. Segurança do Servidor</h2>
              <p>Nossos servidores utilizam:</p>
              <ul>
                <li>HTTPS com certificado SSL/TLS válido</li>
                <li>Firewall e proteção contra ataques</li>
                <li>Atualizações de segurança regulares</li>
                <li>Backups periódicos</li>
              </ul>
            </section>

            <section>
              <h2>13. Contato e Reclamações</h2>
              <p>Dúvidas sobre esta política? Entre em contato:</p>
              <ul>
                <li>
                  <strong>Email:</strong> contato@licitmax.com.br
                </li>
                <li>
                  <strong>WhatsApp:</strong> (44) 99995-7005
                </li>
                <li>
                  <strong>Endereço:</strong> Campo Mourão, PR — Brasil
                </li>
              </ul>
              <p>
                Se discordar de nossa resposta, você pode formalizar reclamação junto à{' '}
                <strong>Autoridade Nacional de Proteção de Dados (ANPD)</strong> via
                www.gov.br/cidadania/pt-br/acesso-a-informacao/lgpd
              </p>
            </section>

            <section>
              <h2>14. Alterações desta Política</h2>
              <p>
                Reservamo-nos o direito de atualizar este documento conforme mudanças na
                legislação ou nas práticas de segurança. Alterações materiais serão comunicadas
                via website. O uso continuado do site constitui aceitação.
              </p>
            </section>

            <div className="pt-6 border-t border-black/10 text-sm text-text-grey/80">
              <p>
                <strong>Última atualização:</strong> 19 de agosto de 2026
              </p>
              <p>
                <strong>Vigência:</strong> a partir da publicação — data de aceitação registrada em
                log ao consentimento inicial
              </p>
            </div>

            <div className="pt-4 text-center text-xs text-text-grey/70">
              <p>© 2026 LicitMax Consultoria. Todos os direitos reservados.</p>
              <p>Este documento é parte integrante dos Termos de Uso do website.</p>
            </div>
          </div>

          <div className="mt-10">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-primary font-semibold hover:text-accent-600 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              Voltar ao início
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
